import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Table } from "../../../../../components/ui/Table";
import { FormatInt } from "../../../../../utils/FormatData";
const TableCustomers = (props) => {
  const { data } = props;

  const COLUMNS = useMemo(() => {
    if (!data.length) {
      return [];
    }

    return [
      {
        Header: "Cliente",
        accessor: "vc_customer",
      },
      {
        Header: "Partner",
        accessor: "vc_partner",
      },
      {
        Header: "Proveedor",
        accessor: "vc_provider",
      },
      {
        Header: "Enviados",
        accessor: "i_sent",
        Cell: (rowData) => {
          let value = Number(rowData.row.original.i_sent);
          return FormatInt(value);
        },
      },
      {
        Header: "Single",
        accessor: "i_single",
        Cell: (rowData) => {
          let value = Number(rowData.row.original.i_single);
          return FormatInt(value);
        },
      },
      {
        Header: "Basic",
        accessor: "i_basic",
        Cell: (rowData) => {
          let value = Number(rowData.row.original.i_basic);
          return FormatInt(value);
        },
      },
      {
        Header: "Entregados",
        accessor: "i_delivered",
        Cell: (rowData) => {
          let value = Number(rowData.row.original.i_delivered);
          return FormatInt(value);
        },
      },
      {
        Header: "Fallback",
        accessor: "i_fallback",
        Cell: (rowData) => {
          let value = Number(rowData.row.original.i_fallback);
          return FormatInt(value);
        },
      },
      {
        Header: "Rechazados",
        accessor: "i_rejected",
        Cell: (rowData) => {
          let value = Number(rowData.row.original.i_rejected);
          return FormatInt(value);
        },
      },
      {
        Header: "Leidos",
        accessor: "i_readed",
        Cell: (rowData) => {
          let value = Number(rowData.row.original.i_readed);
          return FormatInt(value);
        },
      },
    ];
  }, [data]);
  return (
    <Table
      data={data}
      columns={COLUMNS}
      config={{
        search: true,
        footer: true,
        printfooter: true,
        pageSize: 10,
        perPage: 10,
        export: true,
      }}
    />
  );
};

TableCustomers.propTypes = {
  data: PropTypes.array,
};

export default TableCustomers;
